import React, { PropTypes } from 'react';

// import {
//   Nav, 
//   NavItem,
//   Navbar,
//   NavDropdown,
//   MenuItem,
// } from 'react-bootstrap';

class Footer extends React.Component {

  constructor(props) {
    super(props);    
    this.state = { expanded: false };
  }
  render() {
    return (
      <div className="footer-container">
        {'© 2017 iAlumni'}                
      </div>
    )
  }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/layout/Footer.js